module.exports = {"version":1,"sections":[{"title":"Focus Standards","fields":[{"label":"Standards","type":"text","data":[]}]},{"title":"Learning Targets","fields":[{"label":"Learning Targets","type":"text","data":[]}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/data/weeklyplantemplate.json
// module id = l23m
// module chunks = 1